import { Image } from 'antd';
import styled from 'styled-components';
import { Trash } from 'icons/Trash';

export const MultiFileWrapper = styled.div`
  position: relative;
  display: flex;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  border: 1px solid var(--v3-black-6);
  gap: 12px;
  width: 100%;
  overflow: hidden;
  && {
    .ant-image {
      .ant-image-mask {
        display: none;
      }
    }
  }
`;

export const FileImage = styled(Image)`
  &&& {
    border-radius: 8px;

    &.ant-image-img {
      object-fit: cover;
    }
  }
`;

export const OverlayWrapper = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;
  padding: 8px;
  display: flex;
  gap: 30px;
  justify-content: space-between;
`;

export const FileName = styled.div`
  color: var(--primary-color);
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.14px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const RightWrapper = styled.div`
  display: flex;
  gap: 4px;
`;

export const TrashIcon = styled(Trash)`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 8px;
  font-size: 16px;
  background: var(--v3-black-2);
  color: var(--v3-black-85);
  padding: 4px;
`;
